export default __webpack_public_path__ + "static/media/Stand alone.f405af62.jpg";